
import React, { useContext, useEffect, useState } from 'react';
import { Image } from 'semantic-ui-react';
import { ManifestContext } from '../cnr/contexts/ManifestContext';
import { uniqueKey } from '../common/keys';
import { gEnums } from '../enums/globalEnums';
import { getElementStyle } from '../styles/formatting';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { _applyManifestFromReact } from 'App';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';

const ManifestPreview = (props) => {

  const { formData } = props ?? {}

  const { setStyleAndClass } = useStyles()

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {})

  const { manifest, themedItems } = aps_global ?? {}
  const { manifest: manifestTheme } = themedItems ?? {}

  //  manifestContext
  const manifestContext = useContext(ManifestContext);
  const { manifest_fns } = manifestContext ?? {}

  const styleAndClass = setStyleAndClass({ item: gEnums.projectStyles.manifest })
  const itemStyle = getElementStyle(manifestTheme, ['fontSize'])

  if (formData) { styleAndClass.className += ' preview' }

  const manifest_current = formData ? formData : manifest
  let { name } = manifest_current ?? {}

  let manifestText = name ? name : 'Mobile Evolution'

  const [manifestUrl, setManifestUrl] = useState()

  useEffect(() => {
    if (_applyManifestFromReact) {
      setManifestUrl(manifest_fns.getManifestUrl(2))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);


  const logo = () => <Image key={uniqueKey('splash-image')} centered src={manifestUrl} alt={'image'} />

  const splash = () => {
    return <div {...styleAndClass}>
      <div className={'splash-content'} style={itemStyle}>{manifestText}</div>
      <div className={'splash-logo'}>{manifestUrl && logo()}</div>
    </div>
  }

  return splash()
}

export default ManifestPreview